import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EvSimulatorComponent } from './pages/ev-simulator/ev-simulator.component';
import { EvSimulatorRoutingModule } from './ev-simulator-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { HouseTypeComponent } from './components/house-type/house-type.component';
import { SharedModule } from '../../shared/shared.module';
import { ChargingStationPlacementComponent } from './components/charging-station-placement/charging-station-placement.component';
import { TranslateModule } from '@ngx-translate/core';
import { AnalyticsModule } from '../../shared/modules/analytics/analytics.module';
import { ChargingStationDistanceComponent } from './components/charging-station-distance/charging-station-distance.component';
import { ElectricPhaseComponent } from './components/electric-phase/electric-phase.component';
import { ContactInfoComponent } from './components/contact-info/contact-info.component';
import { PersonalCalculationComponent } from './components/personal-calculation/personal-calculation.component';
import { EvcApiModule } from '../../shared/modules/evc-api/evc-api.module';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { ExistingClientComponent } from './components/existing-client/existing-client.component';
import { DirectivesModule } from '@app/shared/directives/directives.module';

@NgModule({
  declarations: [
    EvSimulatorComponent,
    HouseTypeComponent,
    ChargingStationPlacementComponent,
    ChargingStationDistanceComponent,
    ElectricPhaseComponent,
    ContactInfoComponent,
    PersonalCalculationComponent,
    ExistingClientComponent,
  ],
  imports: [
    CommonModule,
    EvSimulatorRoutingModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    AnalyticsModule,
    EvcApiModule,
    DirectivesModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EvSimulatorModule {}

// Add translation markers
_('modules.evSimulator.general.title');
_('modules.evSimulator.steps.personalCalculation.flow.step1.title');
_('modules.evSimulator.steps.personalCalculation.flow.step1.description');
_('modules.evSimulator.steps.personalCalculation.flow.step2.title');
_('modules.evSimulator.steps.personalCalculation.flow.step2.description');
_('modules.evSimulator.steps.personalCalculation.flow.step3.title');
_('modules.evSimulator.steps.personalCalculation.flow.step3.description');
_('modules.evSimulator.steps.personalCalculation.flow.step4.title');
_('modules.evSimulator.steps.personalCalculation.flow.step4.description');
_('modules.evSimulator.steps.electricPhase.fields.electricPhase.options.singlePhase.title');
_('modules.evSimulator.steps.electricPhase.fields.electricPhase.options.singlePhase.description');
_('modules.evSimulator.steps.electricPhase.fields.electricPhase.options.threePhase.title');
_('modules.evSimulator.steps.electricPhase.fields.electricPhase.options.threePhase.description');
_('modules.evSimulator.steps.electricPhase.fields.electricPhase.options.threePhaseNeutral.title');
_('modules.evSimulator.steps.electricPhase.fields.electricPhase.options.threePhaseNeutral.description');
_('modules.evSimulator.steps.electricPhase.fields.electricPhase.options.notVisible.title');
_('modules.evSimulator.steps.electricPhase.fields.electricPhase.options.notVisible.description');
